import { Typography } from '@mui/material'

interface Props {
    message: string
}

function ErrorPage({ message = '' }: Props) {
    // TODO: add theme, styling
    return <Typography>{message}</Typography>
}

export default ErrorPage
